import { Check, Copy } from 'lucide-react'
import { AnimatePresence, motion } from 'motion/react'
import { useCopyToClipboardWithDelay } from '@/src/hooks/use-copy-to-clipboard-with-delay'
import { Button, type ButtonProps } from './button'

export default function CopyButton({
  contentToCopy,
  displayContent,
  ...rest
}: ButtonProps & { contentToCopy: string; displayContent: string }) {
  const { mutate: copyTransactionHash, isHolding } =
    useCopyToClipboardWithDelay()

  return (
    <Button
      size='sm'
      type='button'
      className='font-normal group/copy'
      onClick={() => copyTransactionHash(contentToCopy)}
      {...rest}
    >
      <span className='text-primary'>{displayContent}</span>
      <AnimatePresence mode='popLayout'>
        {isHolding && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            transition={{ duration: 0.1 }}
          >
            <Check className='text-success-text' size={16} />
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence mode='popLayout'>
        {!isHolding && (
          <motion.div
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            transition={{ duration: 0.1 }}
          >
            <Copy
              className='text-secondary group-hover/copy:text-link-hover'
              size={16}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </Button>
  )
}
